export default {
  APP_NAME: 'Dziobak',
  STORAGE_PREFIX: 'shorthand',
  DEFAULT_LOCALE: 'pl',
}